import { ArrowNavigation } from '#/components/ArrowNavigation/ArrowNavigation';
import type { CarouselState } from '#/components/Carousel/CarouselState';
import { DotNavigationButton } from '#/components/DotNavigationButton/DotNavigationButton';
import { useI18n } from '#/i18n/hooks/useI18n';
import { range } from '#/utils/functional/array/range';

import {
  TileCarouselNavigationDotsInnerHolder,
  TileCarouselNavigationDotsOuterHolder,
} from './TileCarouselNavigation.styled';

type Props = {
  carouselState: CarouselState;
};

export function TileCarouselNavigation({ carouselState }: Props) {
  const { i18n } = useI18n();

  const { currentPage, pageCount, goToPage, goToPreviousPage, goToNextPage } =
    carouselState;

  return (
    <nav>
      <ArrowNavigation
        nextPage={goToNextPage}
        prevPage={goToPreviousPage}
        current={currentPage}
        total={pageCount}
        outset
      />

      {pageCount > 1 && (
        <TileCarouselNavigationDotsOuterHolder>
          <TileCarouselNavigationDotsInnerHolder>
            {range(pageCount).map((index) => (
              <DotNavigationButton
                key={index}
                onClick={() => goToPage(index)}
                $isActive={index === currentPage}
                title={`${i18n('Go to page')} ${index + 1}`}
              />
            ))}
          </TileCarouselNavigationDotsInnerHolder>
        </TileCarouselNavigationDotsOuterHolder>
      )}
    </nav>
  );
}
